/**
 * 基于window.location.hash的路由组件。
 *
 * @param {Object} config 路由对象
 */
const sweetRouter = async (config) => {
    Object.keys(config).forEach((key, i) => {
        const container = document.getElementById(key);
        if (container) {
            container.style.display = 'none';
        }
    });

    // 绑定onhashchange对象
    if (!window.onhashchange) {
        window.onhashchange = async function (event) {
            initHash(false);
        };
    }

    /**
     * 首次进入页面时对路由的处理相对于hashchange的时候加入了isRetain字段
     * isRetain字段用于控制刷新时是否保留当前页面（不保留跳转到首页）
     *
     * @param {Boolean} isRefresh 用于区分是首次进入还是通过onhashchange进入
     * @returns
     */
    async function initHash(isRefresh) {
        const curKey = location.hash.replace('#', '') || 'index';
        const curConfig = config[curKey];

        if (curConfig && curConfig.isRetain === false && isRefresh) {
            location.href = '#index';
            return;
        }

        Object.keys(config).forEach(async (key, i) => {
            const container = document.getElementById(key);
            if (container) {
                if (curKey === key) {
                    const objOfFun = config[key];
                    const isFunc = typeof objOfFun === 'function';
                    const component = isFunc ? objOfFun : objOfFun.component;
                    const refresh = !isFunc && objOfFun.refresh;

                    if (refresh) {
                        container.innerHTML = await component();
                    } else if (!container.innerHTML) {
                        container.innerHTML = await component();
                    }

                    container.style.display = '';

                    objOfFun.pageReady && objOfFun.pageReady();
                } else {
                    container.style.display = 'none';
                }
            } else {
                throw new Error(`找不到对应的container:${curKey}`);
            }
        });
    }
    await initHash(true);
};

export default sweetRouter;
